import MainSearch from './MainSearch';

// No styled-components — all styles are static CSS in index.html.
// The Wrapper base had `transition: all 0.1s ease-in-out` which animated every CSS
// property change during SC hydration, causing multiple Lighthouse frame captures and
// pushing Speed Index to ~4.3s. Static CSS eliminates both the SC repaint and the transition.
const serverBannerPath =
  'https://carbucomstatic-5141.kxcdn.com/mazout_com/banner_new/CARBU_mazout_';
const imagesObj = {
  homeBannerWinter: 'hiver',
  homeBannerSpring: '2',
  homeBannerSummer: '2',
  homeBannerAutumn: 'automne',
  homeBannerDefault: '2',
};
function getBannerImage(img) {
  var date_obj = new Date();
  var current_month = (date_obj.getMonth() + 1) % 12;
  let bannerImage = img.homeBannerDefault;
  if (current_month >= 0 && current_month <= 3) {
    bannerImage = img.homeBannerWinter;
  } else if (current_month >= 4 && current_month <= 8) {
    bannerImage = img.homeBannerSummer;
  } else if (current_month >= 9 && current_month <= 11) {
    bannerImage = img.homeBannerAutumn;
  } else {
    bannerImage = img.homeBannerDefault;
  }
  return bannerImage;
}

function getBannerImagePath(size) {
  const bannerImagePaths = { xs: 'xs', sm: 'sm', lg: 'lg', xl: 'xl', xxl: 'xxl', default: 'xs' };
  const bannerImage = getBannerImage(imagesObj);
  return `${serverBannerPath}${bannerImage}_${bannerImagePaths[size]}.webp`;
}

const Banner = ({ lang }) => {
  return (
    <div className='banner-wrapper'>
      <picture>
        <source media='(max-width: 420px)' srcSet={getBannerImagePath('xs')} />
        <source media='(min-width: 420px) and (max-width: 460px)' srcSet={getBannerImagePath('xs')} />
        <source media='(min-width: 460.1px) and (max-width: 768px)' srcSet={getBannerImagePath('sm')} />
        <source media='(min-width: 768.1px) and (max-width: 1200px)' srcSet={getBannerImagePath('lg')} />
        <source media='(min-width: 1200.1px) and (max-width: 1400px)' srcSet={getBannerImagePath('xl')} />
        <source media='(min-width: 1400.1px)' srcSet={getBannerImagePath('xxl')} />
        <img
          src={getBannerImagePath('lg')}
          srcSet={`
              ${getBannerImagePath('xs')} 460w,
              ${getBannerImagePath('sm')} 768w,
              ${getBannerImagePath('lg')} 1024w,
              ${getBannerImagePath('xl')} 1280w,
              ${getBannerImagePath('xxl')} 2000w
            `}
          sizes='(max-width: 460px) 460px,
                   ((min-width: 460.1px) and (max-width: 768px)) 768px,
                   ((min-width: 768.1px) and (max-width: 1024px)) 1024px,
                   ((min-width: 1024.1px) and (max-width: 1280px)) 1280px,
                   2000px'
          alt='Banner'
          crossOrigin='anonymous'
          width='2000'
          height='512'
          loading='lazy'
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
        />
      </picture>

      <div className='banner-inner'>
        <div className='banner-search-card'>
          <div className='banner-card-divider'>
            <h1 className='banner-title text-center' suppressHydrationWarning>
              {lang?.home.mainsearch.title}
            </h1>
          </div>
          <div className='card-section'>
            <h2 className='banner-description' suppressHydrationWarning>
              {lang?.home.mainsearch.description}
            </h2>
            <MainSearch lang={lang} isFirst={true} $isHome={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
